import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useUrlParams } from "./useUrlParams";
import { ENTITY } from "../constants";
import { getCurrentShare } from "../store/actions";
import { currentShareSelector } from "../store/v2/currentShare/selectors";

export function useCurrentShareData() {
  const dispatch = useDispatch();
  const timer = useRef(null);
  const { propertyId, experienceId, userId } = useUrlParams();

  const { share } = useSelector(currentShareSelector);

  const fetchCurrentShare = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }

    timer.current = setTimeout(() => {
      dispatch(getCurrentShare(share.propertyId, share.experienceId, share.id, userId));
    }, 300);
  };

  useEffect(() => {
    const listener = ({ detail }) => {
      const { instances } = detail;

      if (instances.includes(+share.id) && share.propertyId && share.experienceId && share.id) {
        fetchCurrentShare();
      }
    };

    const entities = [ENTITY.SHARE];

    entities.forEach((entity) => document.addEventListener(entity, listener));
    return () => entities.forEach((entity) => document.removeEventListener(entity, listener));
  }, [propertyId, experienceId, share, userId]);
}
